import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ segment }) => {

  const details = {
    sections: [
      {
        title: 't(Segment)',
        items: [
          { label: 't(Text)', content: segment.text },
          { label: 't(Score Threshold)', content: segment.score_threshold }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  segment: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview segment={ props.segment } />
})

export default Panel(null, mapPropsToPanel)